import { makeStyles, useTheme } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';
export const Theme = useTheme;

export const submitButtonBox: any = {
	position: 'absolute',
	padding: '0 50px',
	bottom: 0,
	left: 0,
	right: 0,
	zIndex: 3,
	backgroundColor: "#FFF"
};

export const submitButtonContainer: any = {
	display: 'flex',
	justifyContent: 'flex-end',
	padding: '25px 0px',
	margin: 'auto',
	borderTop: "1px solid",
	borderColor: grey[200]
};

export const useStyles = makeStyles(theme => {
	return ({
		root: {
			width: 'auto',
			maxWidth: '90%',
			flexDirection: 'row',
			[theme.breakpoints.down('sm')]: {
				maxWidth: "100%"
			},
		},
		samplesFormContainer: {
			width: 598,
			[theme.breakpoints.down('sm')]: {
				width: "100%"
			},
			padding: 0,
			overflow: 'hidden',
			position: 'relative'
		},
		samplesFormContainerSteps: {
			overflowY: 'auto',
			padding: 50,
			boxSizing: 'border-box',
			height: 'calc(100% - 90px)'
		},
		samplesFormContainerHeader: {},
		samplesFormContainerFooter: {
			top: 'auto',
			bottom: 0,
			backgroundColor: grey[200]
		},
		samplesFormContainerFooterToolbar: {
			paddingLeft: 50,
			paddingRight: 50
		},
		samplesFormContainerFooterCancelButtonBox: {
			display: "flex",
			flexGrow: 1
		},
		editorHeader: {
			marginBottom: 30,
			lineHeight: '32px'
		},
		stepIconText: {
			fill: "#FFF"
		},
		headerDivider: {}
	});
});
